import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { NotFoundComponent } from './not-found/not-found.component';

import { BookingService } from './services/booking.service';
import { SharedService } from './services/shared.service';
import { LoginService } from './services/login.service';
import { RegistrationService } from './services/registration.service';
import { WalletService } from './services/wallet.service';
import { PersistenceService } from './services/Persistence.service';
import { EncryptionService } from './services/Encryption.service';
import { ErrorService } from './services/Error.service';
import { AppUtilityService } from './services/AppUtilityService';
import { LoaderService } from './services/loader.service';
import { AddressBookService } from './services/addressBook.service';
import { TokenInterceptorService } from './services/TokenInterceptor';
import { AdminService } from './services/admin.service';
import { ClearingHouseService } from './services/clearing.house.service';
import { ModalService } from './services/modalService';
import { SuccessService } from './services/success.service';
import { PaymentService } from './services/payment.service';
import { GoogleAnalytics } from './services/googleAnalytics';
import { InstitutionsService } from './services/institutions.service';
import { PromoCodeService } from './services/promo-code.service';

import { LoginCheck } from './guards/loginCheck';
import { environment } from '../environments/environment';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import {HashLocationStrategy, LocationStrategy, NgOptimizedImageModule, PathLocationStrategy} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {NgbDropdownModule} from "@ng-bootstrap/ng-bootstrap";
import {TermsConditionsComponent} from "./terms-conditions/terms-conditions.component";
import { PluginStoresService } from './services/pluginStores.service';
import { UserService } from './services/user.service';

@NgModule({
  declarations: [AppComponent, NotFoundComponent, PaymentSummaryComponent, TermsConditionsComponent],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgOptimizedImageModule,
    FormsModule,
    NgbDropdownModule,
  ],
  providers: [
    BookingService,
    LoginService,
    RegistrationService,
    SharedService,
    WalletService,
    PersistenceService,
    EncryptionService,
    ErrorService,
    AppUtilityService,
    LoaderService,
    AddressBookService,
    AdminService,
    ClearingHouseService,
    ModalService,
    SuccessService,
    PaymentService,
    InstitutionsService,
    PromoCodeService,
    PluginStoresService,
    UserService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    LoginCheck,
    { provide: 'googleTagManagerId', useValue: environment.googleTagID },
    GoogleAnalytics,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
